import { FC } from 'react';
import cs from 'classnames';
import styles from '../index.module.less';
import IconFont from '@/common/components/Base/IconFont';
const Title: FC<{
  icon?: {
    iconHref: string;
  };
  children: any;
  className?: string;
  onRightIconClick?: () => void;
  style?: any;
  rightSlot?: any;
}> = ({
  icon,
  children,
  className,
  onRightIconClick,
  style,
  rightSlot,
}) => {
  return (
    <div className={cs(styles.title, className)} style={style}>
      {
        icon && (
          <div className={styles.leftIcon}>
            <IconFont
              className={styles.icon}
              iconHref={icon.iconHref}></IconFont>
          </div>
        )
      }
      <div className={styles.main}>
        {children}
      </div>
      {
        onRightIconClick && (
          <div className={styles.rightIcon} onClick={onRightIconClick}>
            <IconFont className={styles.arrow} iconHref='pc-common-icon-ic_arrow_right' style={{ fontSize: '10px' }}></IconFont>
          </div>
        )
      }
      {rightSlot}
    </div>
  );
};

export default Title;
